import { useUser } from '@/store/authStore'
import { Header } from '@/components/layout/Header'
import { ReactNode } from 'react'

interface PublicLayoutProps {
  children: ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps) {
  const user = useUser()

  return (
    <>
      <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <a href="/" className="text-2xl font-bold bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
            DersKaynağı
          </a>
          <nav className="flex gap-4 items-center">
            {user ? (
              <Header role={user.role} onMenuClick={() => { }} />
            ) : (
              <>
                <a href="/welcome" className="text-gray-600 hover:text-primary-500 font-medium transition-colors">Giriş Yap</a>
                <a href="/welcome" className="btn btn-primary shadow-glow-primary">Kayıt Ol</a>
              </>
            )}
          </nav>
        </div>
      </header>

      <main>{children}</main>

      <footer className="bg-gray-900 text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent mb-4">DersKaynağı</h3>
              <p className="text-gray-400 text-sm">Birlikte çalışan öğrencilerin yeri: günlük plan, canlı oda, arkadaşlar ve akışla TYT ve AYT hazırlığı.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Dersler</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="/kurslar" className="hover:text-white transition-colors">Tüm Dersler</a></li>
                <li><a href="/kurslar" className="hover:text-white transition-colors">TYT</a></li>
                <li><a href="/kurslar" className="hover:text-white transition-colors">AYT</a></li>
                <li><a href="/kurslar" className="hover:text-white transition-colors">Lise</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Kurumsal</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="/about" className="hover:text-white transition-colors">Hakkımızda</a></li>
                <li><a href="/contact" className="hover:text-white transition-colors">İletişim</a></li>
                <li><a href="/blog" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Yasal</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="/terms" className="hover:text-white transition-colors">Kullanım Şartları</a></li>
                <li><a href="/privacy" className="hover:text-white transition-colors">Gizlilik Politikası</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 flex justify-center">
            
            <img src='/cizyco_logos_band.svg' />
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
            © 2026 DersKaynağı. Tüm hakları saklıdır.
          </div>
        </div>
      </footer>
    </>
  )
}
